module.exports = __webpack_public_path__ + "img/dlz-banner.4fea1be8.png";